import { render, staticRenderFns } from "./PreliminaryAssessment.vue?vue&type=template&id=1da56af8&scoped=true&"
import script from "./PreliminaryAssessment.vue?vue&type=script&lang=js&"
export * from "./PreliminaryAssessment.vue?vue&type=script&lang=js&"
import style0 from "./PreliminaryAssessment.vue?vue&type=style&index=0&id=1da56af8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da56af8",
  null
  
)

export default component.exports